import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import { setSeo } from "../actions/seo"
import AppContext from "../contexts/App"

const useSetSeoMutation = (type) => {
  const typeName = type.type
  const typeId = type.type_id
  const queryClient = useQueryClient()
  const { openSnackBar } = useContext(AppContext)

  const { mutateAsync, isLoading, isError, error } = useMutation(
    (data) => setSeo(type, data),
    {
      onSuccess: (res) => {
        if (typeName !== "paths") {
          queryClient.setQueryData([typeName, typeId], (oldData) => {
            return {
              ...oldData,
              seo: {
                title: res.title ?? "",
                description: res.description ?? "",
                image: res.image ?? "",
              },
            }
          })
        } else {
          queryClient.setQueryData("paths", (oldData) => {
            return oldData.map((p) => {
              if (p.id === path.id) {
                return {
                  ...p,
                  seo: {
                    title: res.title ?? "",
                    description: res.description ?? "",
                    image: res.image ?? "",
                  },
                }
              }
              return p
            })
          })
        }
        openSnackBar({
          message: "SEO Updated",
        })
      },
      onError: (err) => {
        openSnackBar({
          message: "Error updating SEO",
        })
      },
    },
  )

  return { mutateAsync, isLoading, isError, error }
}

export default useSetSeoMutation
